<template>
  <v-card
    class="pa-2 white"
  >
    <v-card-title>
      <h1>{{ title }}</h1>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          {{ description }}
          <div class="mt-5">
            <v-btn
              v-if="site_url"
              color="primary"
              depressed
              :href="site_url"
              target="_blank"
            >
              Перейти на сайт
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12">
              <v-input
                :messages="['Местоположение']"
                prepend-icon="mdi-map-marker"
              >
                {{ location }}
              </v-input>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <lightbox :cells="images.length" :items="images"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'BaseTourism',
  inject: ['theme'],
  props: {
    title: {
      type: String,
      default: null,
    },
    location: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    site_url: {
      type: String,
      default: null,
    },
    images: {
      type: Array,
      default: () => (['1', '2', '3']),
    },
  },
  data: () => ({
    window: 0
  }),
}
</script>
